/**
 * Created by LinChengMing on 2017/10/30.
 */
import axios from 'axios'
//配置http请求头
axios.interceptors.request.use(c => {
  var storage = window.localStorage;
  if (storage.hasOwnProperty("token")) {
    c.headers.Authorization = storage.getItem("token");
  }
  return c;
})



// WEBPACK FOOTER //
// ./src/router/axios/config.js